import { BranchCode } from "api/risk";
import { TabConfig } from "components/navigation/Tabs/useConfigTabs";
import UnderDevelopment from "components/utils/UnderDevelopment";
import { UnemploymentRisk } from "features/subscription-process/contractualization-process/components/risk/UnemploymentRisk";
import ContractGuarantees from "./tabs/ContractGuarantees";
import ContractPersonOverview from "./tabs/ContractPersonOverview";
import { ContractQuotesOverview } from "./tabs/ContractQuotesOverview";
import { ContractRealEstateOverview } from "./tabs/ContractRealEstateOverview";
import { ContractBorrowerOverview } from "./tabs/ContractBorrowerOverview";
import { ContractPetOverview } from "./tabs/ContractPetOverview";
import { ContractCopropertyOverview } from "./tabs/ContractCopropertyOverview";
import { ContractMriInsuredOverview } from "./tabs/ContractMriInsuredOverview";

export const contractInfosUpiTabs: TabConfig[] = [
  {
    id: 1,
    label: 'CONTRACT.TABS.CONTRACT_INFOS.REAL_ESTATE_INFOS',
    content: <ContractRealEstateOverview branchCode={BranchCode.UPI} />
  },
  {
    id: 2,
    label: 'COMMON.QUOTE',
    content: <ContractQuotesOverview />
  },
  {
    id: 3,
    label: 'COMMON.GUARANTEES',
    content: <ContractGuarantees />
  },
  {
    id: 4,
    label: 'COMMON.ENDORSEMENT',
    content: <UnderDevelopment featureName='Avenant' />
  },
  {
    id: 5,
    label: 'COMMON.INSURED',
    content: <ContractPersonOverview />
  },
];

export const contractInfosRgiTabs: TabConfig[] = [
  {
    id: 1,
    label: 'CONTRACT.TABS.CONTRACT_INFOS.REAL_ESTATE_INFOS',
    content: <ContractRealEstateOverview branchCode={BranchCode.RGI} />
  },
  {
    id: 2,
    label: 'COMMON.QUOTE',
    content: <ContractQuotesOverview />
  },
  {
    id: 3,
    label: 'COMMON.GUARANTEES',
    content: <ContractGuarantees />
  },
  {
    id: 4,
    label: 'COMMON.ENDORSEMENT',
    content: <UnderDevelopment featureName='Avenant' />
  },
  {
    id: 5,
    label: 'COMMON.INSURED',
    content: <ContractPersonOverview />
  },
];

export const contractInfosUnemploymentTabsConfig: TabConfig[] = [
  {
    id: 1,
    label: 'CONTRACT.TABS.CONTRACT_INFOS.UNEMPLOYMENT_INFOS',
    content: <UnemploymentRisk />
  },
  {
    id: 2,
    label: 'COMMON.QUOTE',
    content: <ContractQuotesOverview />
  },
  {
    id: 3,
    label: 'COMMON.GUARANTEES',
    content: <ContractGuarantees />
  },
  {
    id: 4,
    label: 'COMMON.ENDORSEMENT',
    content: <UnderDevelopment featureName='Avenant' />
  },
  {
    id: 5,
    label: 'COMMON.INSURED',
    content: <ContractPersonOverview />
  },
];

/** PJ: the contract covers the person of the folder (company or manager) and a formula of guarantees. */
export const contractInfosLegalProtectionTabs: TabConfig[] = [
  {
    id: 1,
    label: 'COMMON.INSURED',
    content: <ContractPersonOverview />
  },
  {
    id: 2,
    label: 'COMMON.QUOTE',
    content: <ContractQuotesOverview />
  },
  {
    id: 3,
    label: 'COMMON.GUARANTEES',
    content: <ContractGuarantees />
  },
  {
    id: 4,
    label: 'COMMON.ENDORSEMENT',
    content: <UnderDevelopment featureName='Avenant' />
  },
];

export const contractInfosBorrowerTabs: TabConfig[] = [
  {
    id: 1,
    label: 'CONTRACT.TABS.CONTRACT_INFOS.BORROWER_INFOS',
    content: <ContractBorrowerOverview />
  },
  {
    id: 2,
    label: 'COMMON.QUOTE',
    content: <ContractQuotesOverview />
  },
  {
    id: 3,
    label: 'COMMON.GUARANTEES',
    content: <ContractGuarantees />
  },
  {
    id: 4,
    label: 'COMMON.ENDORSEMENT',
    content: <UnderDevelopment featureName='Avenant' />
  },
  {
    id: 5,
    label: 'COMMON.INSURED',
    content: <ContractPersonOverview />
  },
];

export const contractInfosPetTabs: TabConfig[] = [
  {
    id: 1,
    label: 'CONTRACT.TABS.CONTRACT_INFOS.PET_INFOS',
    content: <ContractPetOverview />
  },
  {
    id: 2,
    label: 'COMMON.GUARANTEES',
    content: <ContractGuarantees />
  },
  {
    id: 3,
    label: 'COMMON.INSURED',
    content: <ContractPersonOverview />
  },
];

export const contractInfosMriTabs: TabConfig[] = [
  {
    id: 1,
    label: 'CONTRACT.TABS.CONTRACT_INFOS.COPROPERTY_INFOS',
    content: <ContractCopropertyOverview />
  },
  {
    id: 2,
    label: 'COMMON.QUOTE',
    content: <ContractQuotesOverview />
  },
  {
    id: 3,
    label: 'COMMON.GUARANTEES',
    content: <ContractGuarantees />
  },
  {
    id: 4,
    label: 'COMMON.ENDORSEMENT',
    content: <UnderDevelopment featureName='Avenant' />
  },
  {
    id: 5,
    label: 'CONTRACT.TABS.CONTRACT_INFOS.SUBSCRIBER',
    content: <ContractMriInsuredOverview />
  },
];

export const getBranchTabConfig = (branchCode: BranchCode) => {
  switch (branchCode) {
    case BranchCode.UPI:
      return contractInfosUpiTabs
    case BranchCode.RGI:
      return contractInfosRgiTabs
    case BranchCode.Unemployment:
      return contractInfosUnemploymentTabsConfig
    case BranchCode.Borrower:
      return contractInfosBorrowerTabs
    case BranchCode.Pet:
      return contractInfosPetTabs
    case BranchCode.Mri:
      return contractInfosMriTabs
    case BranchCode.LegalProtection:
      return contractInfosLegalProtectionTabs
  }
  return []
}

